import get from 'lodash/get';
import { FieldValues } from 'react-hook-form';
import { optionDisplayLabel } from 'utils/nameOrder';

/**
 * Selected-value label for a contact option, shared by the Contact multi-select wrappers so their
 * chip labels can't drift apart. A string `getOptionLabel` path is routed through
 * `optionDisplayLabel` — so the chip flips to "Last First" under LAST_NAME_FIRST and carries the
 * vacation marker, mirroring the dropdown option list; a function label keeps its own text.
 */
export const resolveContactOptionLabel = <TOption extends FieldValues>(
    option: TOption,
    getOptionLabel: string | ((option: TOption) => string),
    lastNameFirst: boolean
): string | null =>
    typeof getOptionLabel === 'string'
        ? optionDisplayLabel(option, lastNameFirst, get(option, getOptionLabel) ?? '')
        : getOptionLabel(option);
